
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import { type CompleteLiveWatchCard } from '@xt/client/types/record-card'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class CompleteLiveWatchCards extends Vue {
  @Prop() data: CompleteLiveWatchCard
  @Prop({ default: true }) showRefreshBtn: boolean

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
